// extracted by mini-css-extract-plugin
module.exports = {"Screen":"SplashScreenRed_Screen__1Y4BH","ScreenLogo":"SplashScreenRed_ScreenLogo__1H128"};